module.exports = __webpack_public_path__ + "static/media/plan_main.5acc5471.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/plan_main.svg
// module id = 868
// module chunks = 0